<button (click)="copied($event)" #tooltip="bs-tooltip" [tooltip]="tooltipText | translate" class="btn btn-link btn-copy" [ngClass]="btnClass" [appClipboard]="text">
  <ng-content></ng-content>
</button>